// extracted by mini-css-extract-plugin
module.exports = {"aiResultTable":"dp-IP7pPeAA"};